import { CheckboxIEnumValue } from "./ienumvalue";

/**
 * checboxgroup类型
 */
export class CheckboxValue implements CheckboxIEnumValue{

    getEnumValueName():string{
        return this.name;
    }

    getEnumValue():any{
        return this.value;
    }
    
    /**
     * 文本显示
     */
    name:string;

    /**
     * 值显示
     */
    value:string;
}